module.exports = __webpack_public_path__ + "static/media/influencers.b6f95874.png";